{
  "instances": {
    "loggers": {
      "label": "Loggers",
      "application": "Aplicação",
      "filter": {
        "class_only": "somente classe",
        "configured": "configurado"
      },
      "instance": "Instancia",
      "new": "novo",
      "no_loggers_found": "Nunhum logger foi encontrado.",
      "unset": "Redefinir",
      "setting_loglevel_failed": "A configuração de {logger} como {loglevel} falhou."
    }
  }
}
